import { Textarea } from '@panwds/react-form'
import { Body, Bold } from '@panwds/react-ui'
import { DESCRIPTION } from './common/GlobalConstants'
import { getVarValue } from '../../common/utils/Sparky'
import { FF_SHOW_DESCRIPTION } from '../../common/utils/FeatureFlags'

const DescriptionField = () => {
  const showDescription = getVarValue(FF_SHOW_DESCRIPTION, null)
  return <>
    {showDescription && <div className="cm-relative">
      <Body size='sm' addClassName='tw-pb-1 tw-pl-1'><Bold>{DESCRIPTION}</Bold></Body>
      <Textarea
        name={'description'}
        label={'Description'}
        showLabel={false}
        appearance="default"
        register={{
          required: false
        }}
        rowsMax={3}
        rowsMin={3}
      />
    </div>}
  </>
}


export default DescriptionField
